/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.registration-forms.submissions'},
});

const SubmissionsItem = () => (
  <RouteLinkItem
    route="midas/settings/registration-forms/submissions"
    title={messages.title}
  />
);

export default SubmissionsItem;
